<div class="timeline-container-horizontal" *ngIf="ncMode == 'horizontal'" style="--item-hover-color: {{ncItemHoverColor}}">
    <div class="timeline" [ngStyle]="{'border-bottom-color': ncAxisColor}">
        <div class="timeline-item" [class.timeline-item-selected]="ncSelected == i"
            *ngFor="let item of dateObjectArr;let i = index;" (click)="itemClick(ncDate[i], i)"
            [ngStyle]="{'left': i == 0 ? '0' : 'calc(' + item.left + '%' + ' - 2px)', 'background-color': ncSelected == i ? ncItemSelectedColor : ncItemColor}" [title]="ncDate[i]">
        </div>
        <div class="scale" *ngFor="let item of scaleObjectArr;let i = index;"
            [ngStyle]="{'left': 'calc(' + item.left + '%' + ' - 2px)', 'background-color': ncScaleColor}">
        </div>
        <div class="scale-value" *ngFor="let item of scaleObjectArr;let i = index;"
            [ngStyle]="{'left': 'calc(' + item.left + '%' + ' - 16px)', 'color': ncScaleTextColor}">
            {{item.date}}
        </div>
    </div>
</div>

<div class="timeline-container-vertical" *ngIf="ncMode == 'vertical'" style="--item-hover-color: {{ncItemHoverColor}}">
    <div class="timeline" [ngStyle]="{'border-left-color': ncAxisColor}">
        <div class="timeline-item" [class.timeline-item-selected]="ncSelected == i"
            *ngFor="let item of dateObjectArr;let i = index;" (click)="itemClick(ncDate[i], i)"
            [ngStyle]="{'top': i == 0 ? '0' : 'calc(' + item.left + '%' + ' - 2px)', 'background-color': ncSelected == i ? ncItemSelectedColor : ncItemColor}" [title]="ncDate[i]">
        </div>
        <div class="scale" *ngFor="let item of scaleObjectArr;let i = index;"
            [ngStyle]="{'top': 'calc(' + item.left + '%' + ' - 2px)', 'background-color': ncScaleColor}">
        </div>
        <div class="scale-value" *ngFor="let item of scaleObjectArr;let i = index;"
            [ngStyle]="{'top': 'calc(' + item.left + '%' + ' - 12px)', 'color': ncScaleTextColor}">
            {{item.date}}
        </div>
    </div>
</div>